export default {
    bill_id:        'الإشعار',
    bill_date:      'تاريخ الإشعار',
    item_id:        'الصنف',
    client_id:      'العميل',
    company_id:     'المنشئة',
    qty:            'الكمية',
    price:          'السعر',
    total:          'الاجمالي',
    vat:            'الضريبة',
    vat_percentage: 'نسبة الضريبة',
    final_total:    'الصافي',
};
